<template>
    <div
        class="cabinet-supplier-table__row flex flex-justify-sb"
        :data-product-id="product.ItemID"
    >
        <div
            class="cabinet-supplier-table__cell cabinet-supplier-table__cell--pt24"
        >
            <label class="cabinet-cart-checkbox">
                <input
                    type="checkbox"
                    :checked="checked"
                    @change="$emit('onSelectProductsChange', product.ItemID)"
                />
                <span class="cabinet-cart-checkbox__checkmark"></span>
            </label>
        </div>
        <router-link
            :to="{
                name: 'SupplierProductsDetail',
                params: { id: product.ItemID }
            }"
            class="cabinet-supplier-table__cell cabinet-supplier-table__cell--img flex flex-justify-center flex-align-center"
        >
            <img
                :src="product.images.length ? product.images[0].url : null"
                alt=""
                class="cabinet-supplier-table__img ofi"
            />
        </router-link>
        <router-link
            :to="{
                name: 'SupplierProductsDetail',
                params: { id: product.ItemID }
            }"
            tag="div"
            class="cabinet-supplier-table__cell cabinet-supplier-table__cell--content cabinet-supplier-table__cell--p16 cursor-pointer"
        >
            <div v-if="product.Name" class="cabinet-supplier-table__name">
                {{ product.Name }}
            </div>
            <div v-else class="cabinet-supplier-table__name">—</div>
            <div class="d-flex flex-wrap">
                <div class="cabinet-supplier-table__attr">
                    <span class="cabinet-supplier-table__code">Арт.</span>
                    {{ product.Article || '—' }}
                    <v-tooltip
                        v-if="product.sets.length"
                        class="ml-2 cursor-default"
                        title="Артикул гарнитура"
                    >
                        [{{ product.sets[0].set_article }}]
                    </v-tooltip>
                </div>
                <div class="cabinet-supplier-table__attr">
                    {{
                        product.CollectionID
                            ? `«${getNameById(
                                  collections,
                                  'Name',
                                  'CollectionID',
                                  product.CollectionID
                              )}»`
                            : '—'
                    }}
                </div>
                <div
                    v-if="product.Price > 0"
                    class="cabinet-supplier-table__attr"
                >
                    {{ getFormattedNum(product.Price || 0) }}
                    <span class="cabinet-supplier-table__label"
                        >₽/{{
                            getNameById(
                                priceUnitOptions,
                                'abbr',
                                'id',
                                product.PriceUnit
                            )
                        }}
                    </span>
                </div>
                <div v-else class="cabinet-supplier-table__attr">
                    —
                    <span class="cabinet-supplier-table__label">₽/шт.</span>
                </div>
                <div class="cabinet-supplier-table__attr">
                    <span
                        class="cabinet-supplier-table__visibility"
                        :class="{
                            green: visibility == 2,
                            gold: visibility == 1
                        }"
                    >
                        {{ visibilityName }}
                    </span>
                </div>
            </div>
        </router-link>
        <div
            v-click-outside="closeProductMenu"
            class="cabinet-supplier-table__cell pt-3 pt-lg-0 align-self-start align-self-lg-center position-relative"
            @click="toggleProductMenu"
        >
            <button
                type="button"
                class="cabinet-btn-icon cabinet-btn-icon--transparent cabinet-btn-icon--more d-block"
            ></button>
            <div
                v-if="isOpenProductMenu"
                class="app-dropdown app-dropdown--bottom app-dropdown--right"
            >
                <a
                    href="javascript:void(0)"
                    class="app-dropdown__item text-nowrap"
                    @click.prevent="
                        $emit('changeProductVisibility', product.ItemID)
                    "
                    >Изменить видимость</a
                >
                <a
                    href="javascript:void(0)"
                    class="app-dropdown__item text-nowrap"
                    @click.prevent="
                        $emit('changeProductCollection', product.ItemID)
                    "
                    >Изменить коллекцию</a
                >
                <router-link
                    :to="`/account/products/${product.ItemID}/detail`"
                    class="app-dropdown__item text-nowrap"
                    >Открыть</router-link
                >
                <router-link
                    :to="`/account/products/${product.ItemID}`"
                    class="app-dropdown__item text-nowrap"
                    >Редактировать</router-link
                >
                <a
                    href="javascript:void(0)"
                    class="app-dropdown__item text-nowrap"
                    @click.prevent="$emit('deleteProduct', product.ItemID)"
                    >Удалить</a
                >
            </div>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { mapState } from 'vuex'
import getNameById from '@/mixins/getNameById'
import getFormattedNum from '@/utils/getFormattedNum'

export default {
    name: 'SupplierCatalogItem',
    directives: {
        ClickOutside
    },
    mixins: [getNameById],
    props: {
        product: {
            type: Object,
            default: () => {}
        },
        checked: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpenProductMenu: false
        }
    },
    computed: {
        ...mapState('supplierCollections', ['collections']),
        ...mapState('other', ['priceUnitOptions']),
        visibility() {
            if (!this.product.access) return 0
            return this.product.access.AccessLevel
        },
        visibilityName() {
            if (!this.product.access) return 'Не видно никому'
            return this.product.access.AccessLevel == 1
                ? 'Ограниченный доступ'
                : 'Видно всем'
        }
    },
    methods: {
        getFormattedNum(num) {
            return getFormattedNum(num)
        },
        closeProductMenu() {
            this.isOpenProductMenu = false
        },
        toggleProductMenu() {
            this.isOpenProductMenu = !this.isOpenProductMenu
        }
    }
}
</script>
